import $ from "jquery"

function switch_state(change_state_name, el, change_state) {
    const change_state_el = $('[data-menucontent=' + change_state_name + ']'),
        change_container_state = $('[data-menu-container=' + change_state_name + ']');
    change_state_el.toggleClass('active');
    change_container_state.toggleClass('active');
    let hasClass = $(document.body).hasClass('menu-active_' + change_state_name) && el.hasClass('active')

    if (hasClass) {
        $(document.body).removeClass('menu-active_' + change_state_name)
        hasClass = false
    } else {
        hasClass = true
        $(document.body).addClass('menu-active_' + change_state_name)
    }
    var relative_el =  $("#content > .title")
    el.toggleClass('active');
    if (hasClass && relative_el != null) {
        console.log($(window).outerWidth() < 1224, $(window).outerWidth())
        if ($(window).outerWidth() < 1224){
            $('#content .sidebar').css("margin-top", -1 * relative_el.outerHeight()+"px")
        }else{
            $('#content .sidebar').css("margin-top", 0)
        }
    }
    if (!hasClass) {
        $('#content .sidebar').css( "margin-top", 0 )
    }
    // change_state_el.css({
    //     "top": $("body > #wrapper > #header > .header_top").outerHeight()
    // });
    if (change_state) {
        $.cookie(change_state_name, el.hasClass("active") ? 1 : 0, {path: '/'});
    }

}


function InitBurger(){
    $(function () {
        console.log('init burger')
        $('[data-menu]').on('click', function () {
            var el = $(this),
                change_state_name = el.data('menu');
            console.log('click')
            switch_state(change_state_name, el, false)
        });

        $(window).on("resize", function () {
            $(window).find("body").removeAttr("class")
            $('#content .sidebar').css( "margin-top", 0 )
        })

        $('[data-menu]').each(function () {
            var el = $(this),
                change_state_name = el.data('menu'),
                state = parseInt($.cookie(change_state_name));
            if ($(window).outerWidth() > 800) {
                if (state) {
                    console.log('window resize', change_state_name, state)
                    switch_state(change_state_name, el, state)
                }
            }
        });
    });
}

export {
    InitBurger,
    switch_state
}
